// Service para gerenciamento de pessoas
import api from './api';

export const pessoaService = {
  // Buscar todas as pessoas
  getAll: async (filters = {}) => {
    try {
      const params = {};
      
      Object.keys(filters).forEach(key => {
        if (filters[key] && filters[key] !== '') {
          params[key] = filters[key];
        }
      });

      const response = await api.get('/pessoas', { params });
      
      return { 
        data: response.data?.data?.pessoas || response.data?.pessoas || response.data || [], 
        success: true,
        pagination: response.data?.data?.pagination || response.data?.pagination
      };
    } catch (error) {
      console.error('Erro ao buscar pessoas:', error);
      return { data: [], success: false, error: error.message };
    }
  },

  // Buscar pessoa por ID
  getById: async (id) => {
    try {
      const response = await api.get(`/pessoas/${id}`);
      return { data: response.data?.data || response.data, success: true };
    } catch (error) {
      console.error('Erro ao buscar pessoa:', error);
      return { data: null, success: false, error: error.message };
    }
  },

  // Buscar pessoas para autocomplete (nome e CPF)
  search: async (query, { dtype = '' } = {}) => {
    try {
      // `GET /api/pessoas` não conhece o parâmetro `search`: ele aceita
      // `nome`, `cpf`, `email`, `status`, `dtype` e `extensao`. Mandar
      // `search` fazia a API ignorar o filtro e devolver sempre as dez
      // primeiras pessoas da base, independentemente do que se digitasse.
      // O filtro de CPF da API é exato, não parcial: só vale a pena usá-lo
      // com o CPF completo. Enquanto a pessoa digita, busca por nome.
      const termo = String(query || '').trim();
      const apenasDigitos = termo.replace(/\D/g, '');
      const pareceCpf = apenasDigitos.length === 11 && !/[a-zA-ZÀ-ÿ]/.test(termo);

      const params = {
        ...(pareceCpf ? { cpf: apenasDigitos } : { nome: termo }),
        // `dtype` restringe o tipo de cadastro. Para 'Aluno' a API aplica
        // também o recorte por extensão do usuário.
        ...(dtype ? { dtype } : {}),
        limit: 10 // Limitar a 10 resultados para performance
      };

      const response = await api.get('/pessoas', { params });

      return {
        data: response.data?.data?.pessoas || response.data?.pessoas || response.data || [],
        success: true
      };
    } catch (error) {
      console.error('Erro ao buscar pessoas:', error);
      return { data: [], success: false, error: error.message };
    }
  },

  // Buscar pessoas por extensão
  getByExtensao: async (extensaoId, dtype = null) => {
    try {
      // Buscar pessoas da extensão
      const params = {
        extensao: extensaoId,
        limit: 5000  // Aumentar limite para garantir todos os registros
      };
      
      // Se dtype específico foi solicitado, filtra no backend
      if (dtype) {
        params.dtype = dtype;
      }
      
      const response = await api.get('/pessoas', { params });
      
      const pessoas = response.data?.data?.pessoas || response.data?.pessoas || response.data || [];
      
      return { 
        data: pessoas,
        success: true
      };
    } catch (error) {
      console.error('Erro ao buscar pessoas da extensão:', error);
      return { data: [], success: false, error: error.message };
    }
  },

  // Buscar funcionários (para campo "Atribuir ao")
  getFuncionarios: async () => {
    try {
      const params = {
        dtype: 'Funcionario',
        status: 'Ativo',
        limit: 1000
      };
      
      const response = await api.get('/pessoas', { params });
      
      return { 
        data: response.data?.data?.pessoas || response.data?.pessoas || response.data || [], 
        success: true
      };
    } catch (error) {
      console.error('Erro ao buscar funcionários:', error);
      return { data: [], success: false, error: error.message };
    }
  },

  // Criar nova pessoa
  create: async (pessoaData) => {
    try {
      const response = await api.post('/pessoas', pessoaData);
      
      return { 
        data: response.data?.data || response.data, 
        success: true, 
        message: response.data?.message || 'Pessoa criada com sucesso' 
      };
    } catch (error) {
      console.error('Erro ao criar pessoa:', error);
      return { 
        data: null, 
        success: false, 
        error: error.response?.data?.message || error.message 
      };
    }
  },

  // Atualizar pessoa
  update: async (id, pessoaData) => {
    try {
      const response = await api.put(`/pessoas/${id}`, pessoaData);
      
      return { 
        data: response.data?.data || response.data, 
        success: true, 
        message: response.data?.message || 'Pessoa atualizada com sucesso' 
      };
    } catch (error) {
      console.error('Erro ao atualizar pessoa:', error);
      return { 
        data: null, 
        success: false, 
        error: error.response?.data?.message || error.message 
      };
    }
  },

  // Deletar pessoa
  deletePessoa: async (id) => {
    try {
      const response = await api.delete(`/pessoas/${id}`);
      
      return { 
        success: true, 
        message: response.data?.message || 'Pessoa deletada com sucesso' 
      };
    } catch (error) {
      console.error('Erro ao deletar pessoa:', error);
      return { 
        success: false, 
        error: error.response?.data?.message || error.message 
      };
    }
  }
};
